import React, { Component } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import { HeaderBand, exportDocument } from "../../helpers";
import { TriggerLine } from "./index";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";

const headerBand = () => <HeaderBand />;
const useStyles = makeStyles({
  card: {
    minWidth: 275,
  },
});

const TextMaterial = (props) => {
  const classes = useStyles();
  const { title, leftSide, rightSide, dark, hasHeaderBand } = props;
  const firstTitle = (title, dark) => (
    <div>
      <Typography
        variant="h6"
        style={{
          color: dark ? "#eeeeee" : "#0f69b4",
          textAlign: window.innerWidth <= 768 ? "center" : "left",
        }}
        className="mb-3"
      >
        {title}
      </Typography>
    </div>
  );

  const titleBB = (text) => (
    <div>
      <Typography
        variant="h6"
        style={{
          color: dark ? "#eeeeee" : "#0f69b4",
          textAlign: window.innerWidth <= 768 ? "center" : "left",
        }}
      >
        {text}
      </Typography>
    </div>
  );

  const titleSub = (text) => (
    <div>
      <Typography
        variant="subtitle2"
        style={{
          color: dark ? "#eeeeee" : "#0f69b4",
          textAlign: window.innerWidth <= 768 ? "center" : "left",
        }}
      >
        {text}
      </Typography>
    </div>
  );

  const paragraph = (text) => (
    <p className={` pl-1 text-justify ${dark ? "text-white-50" : ""}`}>
      {text.includes("<" || ">") ? ReactHtmlParser(text) : text}
    </p>
  );
  const imageFluid = (imageUrl) => (
    <img src={imageUrl} className="img-fluid" alt="imagen respectiva" />
  );
  const links = (link, content) => (
    <p
      onClick={() => exportDocument(link)}
      class="pl-4 my-0"
      style={{
        cursor: "pointer",
        textDecoration: "underline",
        color: "#0f69b4",
      }}
    >
      {content}
    </p>
  );
  return (
    <Card className={`${classes.card} mb-4 mt-2`}>
      <CardContent className="py-0 my-0 w-100 px-0 pb-1 m-sm-auto">
        <div>{hasHeaderBand && headerBand()}</div>
        <div className="px-3">
          {title && firstTitle(title, dark)}
          <div className="row">
            <div className="col-md-7 mt-3 linea-separacion-columnas">
              {leftSide.map(
                (obj) =>
                  (!!obj.titleBB && titleBB(obj.titleBB)) ||
                  (!!obj.titleSub && titleSub(obj.titleSub)) ||
                  (!!obj.image && imageFluid(obj.image)) ||
                  (!!obj.paragraph && paragraph(obj.paragraph)) ||
                  (!!obj.link && links(obj.link, obj.name)) ||
                  (!!obj.trigger && (
                    <div className="px-3">
                      <TriggerLine />
                    </div>
                  ))
              )}
            </div>
            {!!rightSide && (
              <div className="col-md-5 mt-4">
                {rightSide.map(
                  (obj) =>
                    (!!obj.titleBB && titleBB(obj.titleBB)) ||
                    (!!obj.titleSub && titleSub(obj.titleSub)) ||
                    (!!obj.image && imageFluid(obj.image)) ||
                    (!!obj.paragraph && paragraph(obj.paragraph)) ||
                    (!!obj.link && links(obj.link, obj.name)) ||
                    (!!obj.trigger && (
                      <div className="px-3">
                        <TriggerLine />
                      </div>
                    ))
                )}
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

TextMaterial.propTypes = {
  title: PropTypes.string,
  leftSide: PropTypes.object,
  rightSide: PropTypes.object,
};

const mapStateToProps = (state) => ({
  dark: state.dark,
});

export default connect(mapStateToProps, {})(TextMaterial);
